// ======================================================================
// File Name       : ServiceNewCheckDlg
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Modal, Button, Col, Form } from 'react-bootstrap';
import { MODAL_SIZE } from '../../constants/index';
import ServiceDetail from './ServiceDetail';


const ServiceRegisterEditConfirm = ({
    showModal,
    bsSize,
    service,
    onRegisterEditOk,
    onRegisterEditCancel,
    enterpriseList,
    displayUserType,
    isUsedVideoSpeedSetting,
    videoSpeedSettingConfirmation,
    videoMcJobtemplate,
    isNewMode,
    xmlUploadFileName, // #7498
    rootFlag, // STEP13.0.0 TAS-21617
}) => {
  const style = {
    background: 'none',
    width: 'auto',
    height: 'auto',
    marginLeft: 0,
    left: 0,
  };
  return (
    <Modal
      className="modal-container "
      show={showModal}
      onHide={onRegisterEditCancel}
      size={MODAL_SIZE.lg}
    >
      <Modal.Header onHide={onRegisterEditCancel} closeButton>
        <Modal.Title className="text-center">
          以下の内容で登録します
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ServiceDetail
          service={service}
          enterpriseList={enterpriseList}
          displayUserType={displayUserType}
          isUsedVideoSpeedSetting={isUsedVideoSpeedSetting}
          videoSpeedSettingConfirmation={videoSpeedSettingConfirmation}
          videoMcJobtemplateComfirm={videoMcJobtemplate}
          isConfirm
          isNewMode={isNewMode}
          xmlUploadFileName={xmlUploadFileName} // #7498
          rootFlag ={rootFlag} // STEP13.0.0 TAS-21617
        />
      </Modal.Body>
      <Modal.Footer>
        <Form.Group className="text-center">
          <Col sm={12} className="text-center">
            <Button
              variant="default"
              className="margin-right-20 btn-96"
              onClick={onRegisterEditCancel}
            >
              キャンセル
            </Button>
            <Button variant="primary" className="btn-96" onClick={onRegisterEditOk}>OK</Button>
          </Col>
        </Form.Group>
      </Modal.Footer>
    </Modal>
  );
};

export default ServiceRegisterEditConfirm;
